import React, { useEffect, useState } from "react";
import "./UserCard.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { allapiAction } from "../../../Redux/common/action";

const UserCard = ({ }) => {
  const dispatch = useDispatch();
  const [profileModal, setProfileModal] = useState(false);

  const [userProfile, setUserProfile] = useState({});
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );
  useEffect(() => {
    setUserProfile(get_profile);

    return () => { };
  }, [get_profile]);

  const profileModalShow = () => setProfileModal(true);
  const profileModalHide = () => setProfileModal(false);

  const router = useNavigate();

  const handleProfileData = (e) => {
    const { name, value } = e.target;
    setUserProfile({
      ...userProfile,
      [name]: value,
    });
  };

  async function submitProfileData() {
    if (!userProfile.fullName) {
      toast.error("Please enter full name!");
    } else if (!userProfile.email) {
      toast.error("Please enter email!");
    } else {
      await dispatch(allapiAction.updateUserProfile(userProfile));
      dispatch(allapiAction.getprofile());
      setProfileModal(false);
    }
  }

  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());
    dispatch(allapiAction.getsliderList({ page: "home" }));
    return () => { };
  }, []);

  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="atm-card">

        {/* TOP */}
        <div className="atm-top">
          <img src="img/chip.png" className="atm-chip" alt="chip" />
          <img src="img/logo.png" className="atm-logo" alt="logo" />
        </div>

        {/* CARD NUMBER */}
        <div className="atm-number">
          {get_profile?.referId || "1122 3344 5566"}
        </div>

        {/* USER INFO */}
        <div className="atm-user">
          <img
            src={get_profile?.image || "https://i.pravatar.cc/150"}
            className="atm-user-img"
            alt="user"
          />

          <div className="atm-user-text">
            <h4>{get_profile?.fullName || "Jaishree Sharma"}</h4>
            <p>{get_profile?.email || "jaishreesharma@gmail.com"}</p>
            <p>📱 {get_profile?.phone || "1122334455"}</p>
          </div>
        </div>

        {/* FOOTER */}
        <div className="atm-footer">
          <span>Ref: {get_profile?.isrefferal || "N/A"}</span>

          <span
            className={`atm-status ${get_profile?.status === "active" ? "active" : "inactive"
              }`}
          >
            {get_profile?.status || "inactive"}
          </span>
        </div>


      </div>
    </div>
  );
};

export default UserCard;
